import {Controller, useController} from "react-hook-form";

import {ISelectRangeProps, SelectRange} from "@pg-design/select-range-module";
import {Text} from "@pg-design/text-module";

import * as styles from "./SelectRangeField.module.css";

type IProps = Omit<ISelectRangeProps, "onChange" | "value">;

export function SelectRangeFieldControlled(props: IProps) {
    const {name, ...selectRangeProps} = props;
    const fieldController = useController({name});

    if (!fieldController) {
        throw new Error("SelectRangeFieldControlled is not wrapped in FormProvider, in this case, please wrap it with FormProvider");
    }

    return (
        <Controller
            name={name}
            render={({field, fieldState}) => {
                const error = fieldState.error?.message;
                return (
                    <div>
                        <SelectRange
                            onChange={(fieldName, value) => field.onChange(value)}
                            value={field.value || {lower: "", upper: ""}}
                            name={name}
                            {...selectRangeProps}
                        />
                        {error && (
                            <Text variant="info_txt_1" className={styles.errorText}>
                                {error}
                            </Text>
                        )}
                    </div>
                );
            }}
        />
    );
}
import {Controller, useController} from "react-hook-form";

import {ISelectRangeProps, SelectRange} from "@pg-design/select-range-module";
import {Text} from "@pg-design/text-module";

import * as styles from "./SelectRangeField.module.css";

type IProps = Omit<ISelectRangeProps, "onChange" | "value">;

export function SelectRangeFieldControlled(props: IProps) {
    const {name, ...selectRangeProps} = props;
    const fieldController = useController({name});

    if (!fieldController) {
        throw new Error("SelectRangeFieldControlled is not wrapped in FormProvider, in this case, please wrap it with FormProvider");
    }

    return (
        <Controller
            name={name}
            render={({field, fieldState}) => {
                const error = fieldState.error?.message;
                return (
                    <div>
                        <SelectRange
                            onChange={(fieldName, value) => field.onChange(value)}
                            value={field.value || {lower: "", upper: ""}}
                            name={name}
                            {...selectRangeProps}
                        />
                        {error && (
                            <Text variant="info_txt_1" className={styles.errorText}>
                                {error}
                            </Text>
                        )}
                    </div>
                );
            }}
        />
    );
}
